// extracted by mini-css-extract-plugin
export default {"CheckBox":"CheckBox_CheckBox__vAtgA"};